function singleTagFilter(selected) {
    return x => x.tags.includes(selected);
}

export { singleTagFilter }